const styles = `:host {
  display: inline-flex;
  outline: none;
  max-width: 100%;
}
:host .control {
  border-width: 1px;
  border-style: solid;
  cursor: pointer;
  box-sizing: border-box;
  outline: none;
  border-radius: 4px;
  white-space: normal;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font: var(--goto-button-text-medium);
  height: 36px;
  padding: var(--goto-button-padding, 0 16px);
  min-width: var(--goto-button-min-width, 80px);
  margin: var(--goto-button-margin);
  white-space: nowrap;
  width: 100%;
}
:host .control ::slotted(chameleon-svg[slot=start]) {
  --goto-icon-size: 18px;
  margin: 0 7px 0px -5px;
}
:host .control ::slotted(chameleon-svg[slot=end]) {
  --goto-icon-size: 18px;
  margin: 0 -5px 0px 7px;
}
:host .content {
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
}

:host([size=small]) .control {
  font: var(--goto-button-text-small);
  height: 30px;
  padding: var(--goto-button-padding, 0 14px);
}
:host([size=small]) .control ::slotted(chameleon-svg[slot=start]) {
  --goto-icon-size: 16px;
  margin: 0 6px 0px -4px;
}
:host([size=small]) .control ::slotted(chameleon-svg[slot=end]) {
  --goto-icon-size: 16px;
  margin: 0 -4px 0px 6px;
}

:host([size=large]) .control {
  font: var(--goto-button-text-large);
  height: 42px;
  padding: var(--goto-button-padding, 0 20px);
}
:host([size=large]) .control ::slotted(chameleon-svg[slot=start]) {
  --goto-icon-size: 20px;
  margin: 0 10px -2px -5px;
}
:host([size=large]) .control ::slotted(chameleon-svg[slot=end]) {
  --goto-icon-size: 20px;
  margin: 0 -5px -2px 10px;
}

:host([size=xlarge]) .control {
  font: var(--goto-button-text-xlarge);
  height: 48px;
  padding: var(--goto-button-padding, 0 24px);
}
:host([size=xlarge]) .control ::slotted(chameleon-svg[slot=start]) {
  --goto-icon-size: 22px;
  margin: 0 12px -2px -5px;
}
:host([size=xlarge]) .control ::slotted(chameleon-svg[slot=end]) {
  --goto-icon-size: 22px;
  margin: 0 -5px -2px 12px;
}

:host([variant=primary]) .control {
  background-color: var(--goto-interactive-01);
  border-color: var(--goto-interactive-01);
  color: var(--goto-text-06);
  --goto-icon-color: var(--goto-text-06);
}
:host([variant=primary]) .control:hover {
  background-color: var(--goto-hover-primary);
  border-color: var(--goto-hover-primary);
}
:host([variant=primary]) .control:active {
  background-color: var(--goto-pressed-primary);
  border-color: var(--goto-pressed-primary);
  box-shadow: none;
}
:host([variant=primary]) .control:focus-visible {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}
:host([variant=primary]) .control:-moz-focusring {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}
:host([variant=primary]) .control:disabled {
  background-color: var(--goto-disabled-02);
  border-color: transparent;
  color: var(--goto-text-03);
  cursor: default;
  --goto-icon-color: var(--goto-text-03);
}
:host([variant=primary]) .control .start,
:host([variant=primary]) .control .end {
  display: flex;
  align-items: center;
}

:host([variant=secondary]) .control {
  color: var(--goto-link);
  --goto-icon-color: var(--goto-link);
  border-color: var(--goto-border);
  background-color: var(--goto-interactive-02);
}
:host([variant=secondary]) .control:hover {
  background-color: var(--goto-hover-secondary);
}
:host([variant=secondary]) .control:active {
  background-color: var(--goto-pressed-secondary);
  box-shadow: none;
}
:host([variant=secondary]) .control:focus-visible {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}
:host([variant=secondary]) .control:-moz-focusring {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}
:host([variant=secondary]) .control:disabled {
  background-color: var(--goto-interactive-02);
  border-color: var(--goto-disabled-04);
  color: var(--goto-text-03);
  --goto-icon-color: var(--goto-text-03);
}
:host([variant=secondary]) .control .start,
:host([variant=secondary]) .control .end {
  display: flex;
  align-items: center;
}

:host([variant=tertiary]) .control {
  color: var(--goto-link);
  --goto-icon-color: var(--goto-link);
  border-color: transparent;
  background-color: var(--goto-interactive-02);
}
:host([variant=tertiary]) .control:hover {
  border-color: transparent;
  background-color: var(--goto-hover-secondary);
}
:host([variant=tertiary]) .control:active {
  border-color: transparent;
  background-color: var(--goto-pressed-tertiary);
  box-shadow: none;
}
:host([variant=tertiary]) .control:focus-visible {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}
:host([variant=tertiary]) .control:-moz-focusring {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}
:host([variant=tertiary]) .control:disabled {
  background-color: var(--goto-interactive-02);
  border-color: var(--goto-interactive-02);
  color: var(--goto-text-03);
  --goto-icon-color: var(--goto-text-03);
}
:host([variant=tertiary]) .control .start,
:host([variant=tertiary]) .control .end {
  display: flex;
  align-items: center;
}

:host([variant=tertiary-neutral]) .control {
  color: var(--goto-text-01);
  --goto-icon-color: var(--goto-text-01);
  border-color: transparent;
  background-color: var(--goto-interactive-02);
}
:host([variant=tertiary-neutral]) .control:hover {
  border-color: transparent;
  background-color: var(--goto-hover-secondary);
}
:host([variant=tertiary-neutral]) .control:active {
  border-color: transparent;
  background-color: var(--goto-pressed-tertiary);
  box-shadow: none;
}
:host([variant=tertiary-neutral]) .control:focus-visible {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}
:host([variant=tertiary-neutral]) .control:-moz-focusring {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}
:host([variant=tertiary-neutral]) .control:disabled {
  background-color: var(--goto-interactive-02);
  border-color: var(--goto-interactive-02);
  color: var(--goto-text-03);
  --goto-icon-color: var(--goto-text-03);
}
:host([variant=tertiary-neutral]) .control .start,
:host([variant=tertiary-neutral]) .control .end {
  display: flex;
  align-items: center;
}

:host([variant=success]) .control {
  color: var(--goto-text-06);
  --goto-icon-color: var(--goto-text-06);
  border-color: var(--goto-success-01);
  background-color: var(--goto-success-01);
}
:host([variant=success]) .control:hover {
  background-color: var(--goto-hover-success);
  border-color: var(--goto-hover-success);
}
:host([variant=success]) .control:active {
  background-color: var(--goto-pressed-success);
  border-color: var(--goto-pressed-success);
  box-shadow: none;
}
:host([variant=success]) .control:focus-visible {
  border-color: var(--goto-focus-success);
  box-shadow: var(--goto-highlight-success);
}
:host([variant=success]) .control:-moz-focusring {
  border-color: var(--goto-focus-success);
  box-shadow: var(--goto-highlight-success);
}
:host([variant=success]) .control:disabled {
  background-color: var(--goto-disabled-02);
  border-color: transparent;
  color: var(--goto-text-03);
  cursor: default;
  --goto-icon-color: var(--goto-text-03);
}
:host([variant=success]) .control .start,
:host([variant=success]) .control .end {
  display: flex;
  align-items: center;
}

:host([variant=danger]) .control {
  background-color: var(--goto-danger-01);
  border-color: var(--goto-danger-01);
  color: var(--goto-text-06);
  --goto-icon-color: var(--goto-text-06);
}
:host([variant=danger]) .control:hover {
  background-color: var(--goto-hover-danger);
  border-color: var(--goto-hover-danger);
}
:host([variant=danger]) .control:active {
  background-color: var(--goto-pressed-danger);
  border-color: var(--goto-pressed-danger);
  box-shadow: none;
}
:host([variant=danger]) .control:focus-visible {
  border-color: var(--goto-focus-danger);
  box-shadow: var(--goto-highlight-error);
}
:host([variant=danger]) .control:-moz-focusring {
  border-color: var(--goto-focus-danger);
  box-shadow: var(--goto-highlight-error);
}
:host([variant=danger]) .control:disabled {
  background-color: var(--goto-disabled-02);
  border-color: transparent;
  color: var(--goto-text-03);
  cursor: default;
  --goto-icon-color: var(--goto-text-03);
}
:host([variant=danger]) .control .start,
:host([variant=danger]) .control .end {
  display: flex;
  align-items: center;
}

:host([variant=neutral]) .control {
  color: var(--goto-text-01);
  background-color: var(--goto-interactive-02);
  border-color: var(--goto-border);
  --goto-icon-color: var(--goto-text-01);
}
:host([variant=neutral]) .control:hover {
  background-color: var(--goto-hover-secondary);
  border-color: var(--goto-border);
}
:host([variant=neutral]) .control:active {
  background-color: var(--goto-pressed-secondary);
  border-color: var(--goto-border);
  box-shadow: none;
}
:host([variant=neutral]) .control:focus-visible {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}
:host([variant=neutral]) .control:-moz-focusring {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}
:host([variant=neutral]) .control:disabled {
  background-color: var(--goto-interactive-02);
  border-color: var(--goto-disabled-04);
  color: var(--goto-text-03);
  --goto-icon-color: var(--goto-text-03);
}
:host([variant=neutral]) .control .start,
:host([variant=neutral]) .control .end {
  display: flex;
  align-items: center;
}

:host([variant=neutral-inverse]) .control {
  color: var(--goto-inverse-02);
  --goto-icon-color: var(--goto-inverse-02);
  background-color: var(--goto-interactive-02);
  border-color: var(--goto-button-neutral-inverse-border);
}
:host([variant=neutral-inverse]) .control:hover {
  background-color: var(--goto-button-neutral-inverse-background-hover);
  border-color: var(--goto-inverse-border);
}
:host([variant=neutral-inverse]) .control:active {
  background-color: var(--goto-button-neutral-inverse-background-active);
  border-color: var(--goto-inverse-border);
  box-shadow: none;
}
:host([variant=neutral-inverse]) .control:focus-visible {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}
:host([variant=neutral-inverse]) .control:-moz-focusring {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}
:host([variant=neutral-inverse]) .control:disabled {
  background-color: var(--goto-interactive-02);
  border-color: var(--goto-disabled-04);
  color: var(--goto-text-03);
  --goto-icon-color: var(--goto-text-03);
}
:host([variant=neutral-inverse]) .control .start,
:host([variant=neutral-inverse]) .control .end {
  display: flex;
  align-items: center;
}

:host([fullwidth]) {
  width: 100%;
}
:host([fullwidth]) .control {
  width: 100%;
}

:host([disabled]) .content {
  pointer-events: none;
}`; export default styles;